import { getApiUrl } from 'config/appConfig';

export const FALLBACK_PRODUCT_IMAGE = '/assets/sin_foto.svg';

const isBlank = (value?: string | null): boolean => !value || !value.trim();

/** Resuelve URL de imagen; si falta o es inválida, usa placeholder local. */
export const getProductImageUrl = (imageUrl?: string | null, _codigo?: string | null): string => {
  if (isBlank(imageUrl)) return FALLBACK_PRODUCT_IMAGE;

  const trimmed = imageUrl!.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:')) {
    return trimmed;
  }
  if (trimmed.startsWith('/')) {
    const base = getApiUrl().replace(/\/$/, '');
    return `${base}${trimmed}`;
  }
  return trimmed;
};

const handleImageError = (e: { currentTarget: HTMLImageElement }) => {
  const img = e.currentTarget;
  if (img.getAttribute('src')?.includes('sin_foto')) return;
  img.onerror = null;
  img.src = FALLBACK_PRODUCT_IMAGE;
};

export const getLazyImageProps = (src: string, alt: string) => ({
  src,
  alt,
  loading: 'lazy' as const,
  decoding: 'async' as const,
  onError: handleImageError,
});

/** Título visible: el API a veces manda name vacío y el texto en description. */
export const getProductDisplayName = (product: {
  name?: string | null;
  description?: string | null;
  sku?: string | null;
}): string => {
  if (!isBlank(product.name)) return product.name!.trim();
  if (!isBlank(product.description)) return product.description!.trim();
  if (!isBlank(product.sku)) return product.sku!.trim();
  return 'Producto';
};
